import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useAuthContext} from '../components/AuthComponents';

const Logout: React.FC = () => {
    const authContext = useAuthContext();

    useEffect(() => {
        authContext.logout();
    }, []);

    return (
        <div className='logoutPage'>
            <h2>ログアウトしました。</h2>
            <p>
                <Link to='/'>ログイン</Link>
            </p>
        </div>
    );
};

export default Logout;
